import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { uniqueId } from 'lodash';

/**
 * The "what is this column counting?" marker: a small info icon beside a column name, explaining the number
 * under it on hover.
 *
 * <p>Exists because two tables in Manage Apps both head a column "Install Count" and mean different things by
 * it — the adverts tab counts installs of that advert, All Apps counts every install of the app, advertised or
 * not (UN-3372 items 4 and 5). The numbers legitimately differ for the same app, and nothing on the page said
 * why.
 *
 * <p>id is minted once per instance rather than per render: UncontrolledTooltip binds to its target by id, and
 * a fresh id on every render leaves the tooltip pointing at an element that is no longer there.
 */
class XMColumnHint extends React.Component {
  state = {
    id: `ColumnHint-${uniqueId()}`,
  };

  render() {
    const { hint, placement } = this.props;
    if (!hint) return null;
    return (
      <React.Fragment>
        <i
          id={this.state.id}
          className="icon-info ms-1 text-muted"
          style={{ cursor: 'help', fontSize: '0.8rem' }}
          // The icon is the only thing carrying this explanation, so it has to be reachable without a
          // pointer: tabbable, named, and announced as the description of the column it sits in.
          tabIndex={0}
          role="note"
          aria-label={hint}
        />
        <UncontrolledTooltip placement={placement || 'top'} target={this.state.id}>
          {hint}
        </UncontrolledTooltip>
      </React.Fragment>
    );
  }
}

XMColumnHint.propTypes = {
  hint: PropTypes.string,
  placement: PropTypes.string,
};

export default XMColumnHint;
